// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aZBn","questions":"styles_questions__2tbaS","footer":"styles_footer__3gldZ"};